<div>
  <div *ngIf="organizationDetailData">
    <form (ngSubmit)="onSubmit()" [formGroup]="organizationForm">
      <div class="headline-with-buttons">
        <markant-platform-ui-page-header class="headline">
          {{ organizationDetailData.name }}
        </markant-platform-ui-page-header>

        <div class="action-buttons">
          <markant-button
            colorScheme="primary"
            type="button"
            variant="clear"
            [loading]="isLoading"
            (click)="cancelForm()"
            (keydown.enter)="cancelForm()"
          >
            {{ 'common.cancel' | transloco }}
          </markant-button>
          <markant-button
            colorScheme="primary"
            type="submit"
            [loading]="isLoading"
          >
            <markant-icon icon="m_checkmark" slot="icon-leading"></markant-icon>
            {{ 'common.save' | transloco }}
          </markant-button>
        </div>
      </div>

      <div
        class="organization-grid"
        [class.organization-grid-compact]="!isCurrentUserPlatformAdmin"
      >
        <div class="grid-group">
          <markant-platform-ui-card
            class="grid-item"
            [headline]="'organization.details.masterdata' | transloco"
          >
            <markant-input
              *ngIf="organizationForm.controls.name as name"
              formControlName="name"
              id="organization-name"
              data-cy="input-organization-name"
              required
              autocomplete="organization"
              type="text"
              [error]="
                name.errors
                  | formControlError: showError || name.touched || name.dirty
              "
              [errorText]="
                name.errors
                  | formControlKeyError
                    : 'organization.details.fields.name.validation'
                    : showError || name.touched || name.dirty
                  | transloco
              "
              [label]="'organization.details.fields.name.label' | transloco"
              [outlined]="true"
              [showLabelHint]="true"
            ></markant-input>
            <markant-input
              *ngIf="organizationForm.controls.phone as phone"
              formControlName="phone"
              id="organization-contactPhone"
              data-cy="input-organization-contact-phone"
              type="text"
              [error]="
                phone.errors
                  | formControlError: showError || phone.touched || phone.dirty
              "
              [errorText]="
                phone.errors
                  | formControlKeyError
                    : 'organization.details.fields.phone.validation'
                    : showError || phone.touched || phone.dirty
                  | transloco
              "
              [label]="
                'organization.details.fields.contactPhone.label' | transloco
              "
              [outlined]="true"
              [showLabelHint]="!isDemoOrganization"
              [required]="!isDemoOrganization"
            ></markant-input>
            <markant-seperator></markant-seperator>
            <markant-input
              *ngIf="
                !organizationForm.controls.salesTaxNotAvailable.value &&
                organizationForm.controls['salesTaxId'] as salesTaxId
              "
              formControlName="salesTaxId"
              id="salesTaxId"
              data-cy="input-sales-tax-id"
              name="salesTaxId"
              [error]="
                salesTaxId.errors
                  | formControlError
                    : showError || salesTaxId.touched || salesTaxId.dirty
              "
              [errorText]="
                salesTaxId.errors
                  | formControlKeyError
                    : 'organization.details.fields.salesTaxId.validation'
                    : showError || salesTaxId.touched || salesTaxId.dirty
                  | transloco
              "
              [label]="
                'organization.details.fields.salesTaxId.label' | transloco
              "
              [outlined]="true"
              [showLabelHint]="!isDemoOrganization"
              [required]="!isDemoOrganization"
            ></markant-input>
            <markant-input
              *ngIf="
                organizationForm.controls.salesTaxNotAvailable.value &&
                organizationForm.controls['taxNumber'] as taxNumber
              "
              formControlName="taxNumber"
              id="taxNumber"
              data-cy="input-tax-number"
              [error]="
                taxNumber.errors
                  | formControlError
                    : showError || taxNumber.touched || taxNumber.dirty
              "
              [errorText]="
                taxNumber.errors
                  | formControlKeyError
                    : 'organization.details.fields.taxNumber.validation'
                    : showError || taxNumber.touched || taxNumber.dirty
                  | transloco
              "
              [label]="
                'organization.details.fields.taxNumber.label' | transloco
              "
              [outlined]="true"
              [showLabelHint]="!isDemoOrganization"
              [required]="!isDemoOrganization"
            ></markant-input>
            <markant-checkbox
              class="sales-tax-checkbox"
              formControlName="salesTaxNotAvailable"
              id="taxNumber_activated_checkbox"
              [small]="true"
              (ngModelChange)="changeTaxNumberRequired($event)"
            >
              <span
                [class.sales-tax-checkbox-disabled]="
                  organizationForm.controls.salesTaxNotAvailable.disabled
                "
              >
                {{
                  'organization.details.fields.salesTaxIdNotAvailable.label'
                    | transloco
                }}
              </span>
            </markant-checkbox>
            <div class="commercial-register">
              <markant-input
                *ngIf="
                  organizationForm.controls
                    .commercialRegister as commercialRegister
                "
                formControlName="commercialRegister"
                id="organization-commercialRegister"
                data-cy="input-organization-commercial-register"
                autocomplete="new-password"
                type="text"
                [error]="
                  commercialRegister.errors
                    | formControlError
                      : showError ||
                          commercialRegister.touched ||
                          commercialRegister.dirty
                "
                [errorText]="
                  commercialRegister.errors
                    | formControlKeyError
                      : 'organization.details.fields.commercialRegister.validation'
                      : showError ||
                          commercialRegister.touched ||
                          commercialRegister.dirty
                    | transloco
                "
                [label]="
                  'organization.details.fields.commercialRegister.label'
                    | transloco
                "
                [outlined]="true"
                [showLabelHint]="false"
              ></markant-input>
              <markant-input
                *ngIf="
                  organizationForm.controls
                    .commercialRegisterId as commercialRegisterId
                "
                formControlName="commercialRegisterId"
                id="organization-commercialRegisterId"
                data-cy="input-organization-commercial-register-id"
                autocomplete="new-password"
                type="text"
                [error]="
                  commercialRegisterId.errors
                    | formControlError
                      : showError ||
                          commercialRegisterId.touched ||
                          commercialRegisterId.dirty
                "
                [errorText]="
                  commercialRegisterId.errors
                    | formControlKeyError
                      : 'organization.details.fields.commercialRegisterId.validation'
                      : showError ||
                          commercialRegisterId.touched ||
                          commercialRegisterId.dirty
                    | transloco
                "
                [label]="
                  'organization.details.fields.commercialRegisterId.label'
                    | transloco
                "
                [outlined]="true"
                [showLabelHint]="false"
              ></markant-input>
            </div>
            <markant-seperator></markant-seperator>
            <markant-input
              *ngIf="organizationForm.controls.gln as gln"
              formControlName="gln"
              id="organization-gln"
              data-cy="input-organization-gln"
              type="text"
              [error]="
                gln.errors
                  | formControlError: showError || gln.touched || gln.dirty
              "
              [errorText]="
                gln.errors
                  | formControlKeyError
                    : 'organization.details.fields.gln.validation'
                    : showError || gln.touched || gln.dirty
                  | transloco
              "
              [label]="'organization.details.fields.gln.label' | transloco"
              [outlined]="true"
              [showLabelHint]="false"
            ></markant-input>
            <ng-container *ngIf="isCurrentUserPlatformAdmin && isEzrCustomer">
              <markant-input
                *ngIf="organizationForm.controls['masterKin'] as masterKin"
                class="registration-form-input"
                id="masterKin"
                data-cy="masterKin"
                formControlName="masterKin"
                name="masterKin"
                [maxlength]="8"
                [placeholder]="'22211100'"
                [helperCharacterCounter]="true"
                [helper]="
                  'organization.details.fields.masterKin.hint' | transloco
                "
                [error]="
                  masterKin.errors
                    | formControlError
                      : showError || masterKin.touched || masterKin.dirty
                "
                [errorText]="
                  masterKin.errors
                    | formControlKeyError
                      : 'organization.details.fields.masterKin.validation'
                      : showError || masterKin.touched || masterKin.dirty
                    | transloco
                "
                [label]="'register.organization.masterKin' | transloco"
                [showLabelHint]="!!organizationDetailData.masterKin"
                [required]="
                  !!organizationDetailData.masterKin &&
                  organizationDetailData.status !==
                    OrganizationStatus.DEACTIVATED
                "
                [outlined]="true"
                (valueChange)="onMasterKinChange($event.detail)"
              ></markant-input>
              <ng-container
                formArrayName="furtherKins"
                *ngIf="isCurrentUserPlatformAdmin"
              >
                <div class="further-kins">
                  <span>
                    {{ 'register.organization.furtherKins' | transloco }}
                  </span>
                  <markant-icon-button
                    class="further-kins-button"
                    colorScheme="dark"
                    icon="m_plus"
                    (click)="addFurtherKin()"
                    (keydown.enter)="addFurtherKin()"
                  ></markant-icon-button>
                </div>

                <ng-container
                  *ngFor="let furtherKin of furtherKins.controls; let i = index"
                >
                  <div [formGroupName]="i">
                    <markant-input
                      *ngIf="furtherKin.get('kin') as kin"
                      class="registration-form-input"
                      id="'further-kin-'{{ i }}"
                      name="'further-kin-name-'{{ i }}"
                      [maxlength]="8"
                      [placeholder]="'22211100'"
                      [helperCharacterCounter]="true"
                      [error]="
                        kin.errors
                          | formControlError
                            : showError || kin.touched || kin.dirty
                      "
                      [formControlName]="'kin'"
                      [helper]="
                        'organization.details.fields.masterKin.hint' | transloco
                      "
                      [errorText]="
                        kin.errors
                          | formControlKeyError
                            : 'organization.details.fields.furtherKins.validation'
                            : showError || kin.touched || kin.dirty
                          | transloco
                      "
                      [label]="
                        ('organization.details.fields.furtherKins.label'
                          | transloco) +
                        ' - ' +
                        (i + 1)
                      "
                      [showLabelHint]="true"
                    >
                      <markant-icon
                        slot="markant-input-icon-trailing"
                        icon="m_minus"
                        [style.cursor]="'pointer'"
                        [clickable]="true"
                        (click)="removeFurtherKin(i)"
                        (keydown.enter)="removeFurtherKin(i)"
                      ></markant-icon>
                    </markant-input>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
            <markant-input
              *ngIf="organizationForm.controls['naceCode'] as naceCode"
              formControlName="naceCode"
              id="organization-naceCode"
              data-cy="input-organization-naceCode"
              type="text"
              [error]="
                naceCode.errors
                  | formControlError
                    : showError || naceCode.touched || naceCode.dirty
              "
              [errorText]="
                naceCode.errors
                  | formControlKeyError
                    : 'organization.details.fields.naceCode.validation'
                    : showError || naceCode.touched || naceCode.dirty
                  | transloco
              "
              [label]="'organization.details.fields.naceCode.label' | transloco"
              [outlined]="true"
              [showLabelHint]="false"
            ></markant-input>
            <markant-seperator></markant-seperator>
            <markant-select
              *ngIf="organizationForm.controls['industry'] as industry"
              id="organization-industry"
              formControlName="industry"
              [options]="industryOptions"
              [error]="
                industry.errors
                  | formControlKeyError
                    : 'organization.details.fields.industry.validation'
                    : showError || industry.touched || industry.dirty
                  | transloco
              "
              [label]="'organization.details.fields.industry.label' | transloco"
              [outlined]="true"
              [showLabelHint]="
                organizationDetailData.qualificationLevel ===
                QualificationLevel.LEVEL_3
              "
              [required]="
                organizationDetailData.qualificationLevel ===
                QualificationLevel.LEVEL_3
              "
            >
            </markant-select>

            <markant-select
              *ngIf="
                isCurrentUserPlatformAdmin &&
                organizationForm.controls[
                  'organizationType'
                ] as organizationType
              "
              formControlName="organizationType"
              id="organization-organizationType"
              [options]="organizationTypeOptions"
              [error]="
                organizationType.errors
                  | formControlKeyError
                    : 'organization.details.fields.organizationType.validation'
                    : showError ||
                        organizationType.touched ||
                        organizationType.dirty
                  | transloco
              "
              [label]="
                'organization.details.fields.organizationType.label' | transloco
              "
              [outlined]="true"
              [showLabelHint]="
                organizationDetailData.qualificationLevel ===
                QualificationLevel.LEVEL_3
              "
              [required]="
                organizationDetailData.qualificationLevel ===
                QualificationLevel.LEVEL_3
              "
            >
            </markant-select>
          </markant-platform-ui-card>
          <markant-platform-ui-card
            *ngIf="isCurrentUserPlatformAdmin"
            class="grid-item"
            [headline]="'organization.details.platformData' | transloco"
          >
            <markant-input
              data-cy="input-ezr-customer"
              [label]="
                'organization.details.fields.ezrCustomer.label' | transloco
              "
              [outlined]="true"
              [disabled]="true"
              [value]="
                'organization.details.fields.ezrCustomer.options.' +
                  organizationDetailData.ezrCustomer | transloco
              "
              [useCustomLayout]="true"
            >
            </markant-input>
            <markant-checkbox
              class="markant-organization-checkbox"
              formControlName="markantOrganization"
              [small]="true"
              (checkedChange)="openMarkantOrganizationChangeConfirmDialog()"
              ><span>{{
                'organization.details.fields.markantOrganization.label'
                  | transloco
              }}</span></markant-checkbox
            >
            <markant-input
              data-cy="input-qualification-level"
              [disabled]="true"
              [value]="
                'organization.details.fields.qualificationLevel.short.' +
                  organizationDetailData.qualificationLevel | transloco
              "
              [label]="
                'organization.details.fields.qualificationLevel.label'
                  | transloco
              "
              [outlined]="true"
            >
            </markant-input>
            <markant-input
              data-cy="input-created-at"
              [disabled]="true"
              [value]="
                organizationDetailData.createdAt &&
                (organizationDetailData.createdAt
                  | date
                    : 'dd MMMM yyyy'
                    : ''
                    : translocoService.getActiveLang())
              "
              [label]="'organization.profile.creationDate' | transloco"
              [outlined]="true"
            >
            </markant-input>
            @if (isCurrentUserPlatformAdmin) {
              <markant-input
                data-cy="input-lead-context"
                [disabled]="true"
                [value]="organizationDetailData.leadContext"
                [label]="'organization.profile.leadContext' | transloco"
                [outlined]="true"
              >
              </markant-input>
            }
            <markant-input
              data-cy="input-documents-count"
              [disabled]="true"
              [value]="documentCount"
              [label]="'organization.profile.documentsCount' | transloco"
              [outlined]="true"
            >
            </markant-input>
            <markant-input
              data-cy="input-members-count"
              [disabled]="true"
              [value]="userCount"
              [label]="'organization.profile.membersCount' | transloco"
              [outlined]="true"
            >
            </markant-input>
            <markant-seperator></markant-seperator>
            <markant-input
              data-cy="input-organization-status"
              [disabled]="true"
              [value]="
                'organization.profile.organizationStatus.' +
                  organizationDetailData.status | transloco
              "
              [label]="'organization.profile.status' | transloco"
              [outlined]="true"
            >
            </markant-input>
          </markant-platform-ui-card>
        </div>

        <div class="grid-group">
          <div class="grid-item">
            <markant-platform-ui-card
              [headline]="'organization.details.address' | transloco"
            >
              <ng-container formGroupName="address">
                <div class="address address-street">
                  <markant-input
                    *ngIf="organizationForm.get('address.street') as street"
                    class="flex-3"
                    formControlName="street"
                    id="organization-street"
                    data-cy="input-organization-street"
                    type="text"
                    [error]="
                      street.errors
                        | formControlError
                          : showError || street.touched || street.dirty
                    "
                    [errorText]="
                      street.errors
                        | formControlKeyError
                          : 'organization.details.fields.address.street.validation'
                          : showError || street.touched || street.dirty
                        | transloco
                    "
                    [label]="
                      'organization.details.fields.address.street.label'
                        | transloco
                    "
                    [outlined]="true"
                    [showLabelHint]="!isDemoOrganization"
                    [required]="!isDemoOrganization"
                  ></markant-input>
                  <markant-input
                    *ngIf="
                      organizationForm.get(
                        'address.streetNumber'
                      ) as streetNumber
                    "
                    class="flex-1"
                    formControlName="streetNumber"
                    id="organization-streetNumber"
                    data-cy="input-organization-streetNumber"
                    type="text"
                    [error]="
                      streetNumber.errors
                        | formControlError
                          : showError ||
                              streetNumber.touched ||
                              streetNumber.dirty
                    "
                    [errorText]="
                      streetNumber.errors
                        | formControlKeyError
                          : 'organization.details.fields.address.streetNumber.validation'
                          : showError ||
                              streetNumber.touched ||
                              streetNumber.dirty
                        | transloco
                    "
                    [label]="
                      'organization.details.fields.address.streetNumber.label'
                        | transloco
                    "
                    [outlined]="true"
                    [showLabelHint]="!isDemoOrganization"
                    [required]="!isDemoOrganization"
                  ></markant-input>
                </div>
                <div class="address address-city">
                  <markant-input
                    *ngIf="organizationForm.get('address.zipCode') as zipCode"
                    id="organization-zipCode"
                    data-cy="input-organization-zipCode"
                    formControlName="zipCode"
                    autocomplete="postal-code"
                    [label]="
                      'organization.details.fields.address.zipCode.label'
                        | transloco
                    "
                    [error]="
                      zipCode.errors
                        | formControlError
                          : showError || zipCode.touched || zipCode.dirty
                    "
                    [errorText]="
                      zipCode.errors
                        | formControlKeyError
                          : 'organization.details.fields.address.zipCode.validation'
                          : showError || zipCode.touched || zipCode.dirty
                        | transloco
                    "
                    [showLabelHint]="!isDemoOrganization"
                    [required]="!isDemoOrganization"
                    [outlined]="true"
                  >
                  </markant-input>
                  <markant-input
                    *ngIf="organizationForm.get('address.city') as city"
                    id="organization-city"
                    data-cy="input-organization-city"
                    formControlName="city"
                    autocomplete="address-level2"
                    [label]="
                      'organization.details.fields.address.city.label'
                        | transloco
                    "
                    [error]="
                      city.errors
                        | formControlError
                          : showError || city.touched || city.dirty
                    "
                    [errorText]="
                      city.errors
                        | formControlKeyError
                          : 'organization.details.fields.address.city.validation'
                          : showError || city.touched || city.dirty
                        | transloco
                    "
                    [showLabelHint]="!isDemoOrganization"
                    [required]="!isDemoOrganization"
                    [outlined]="true"
                  >
                  </markant-input>
                </div>

                @if (
                  organizationForm.controls.address.controls.countryCode;
                  as countryCode
                ) {
                  <markant-platform-ui-country-select
                    data-cy="select-country"
                    [control]="countryCode"
                    [outlined]="true"
                    [required]="!isDemoOrganization"
                    [label]="
                      'organization.details.fields.address.countryCode.label'
                        | transloco
                    "
                    [placeholder]="
                      'organization.details.fields.address.countryCode.placeholder'
                        | transloco
                    "
                    [error]="
                      countryCode.errors
                        | formControlKeyError
                          : 'organization.details.fields.address.countryCode.validation'
                          : showError || countryCode.dirty
                    "
                    (valueChanged)="updateCountryChanged()"
                  >
                  </markant-platform-ui-country-select>
                }
              </ng-container>
              <markant-seperator></markant-seperator>
              <markant-input
                *ngIf="
                  organizationForm.controls['billingEmail'] as billingEmail
                "
                id="organization-billingEmail"
                data-cy="input-organization-billingEmail"
                formControlName="billingEmail"
                autocomplete="email"
                [label]="
                  'organization.details.fields.billingEmail.label' | transloco
                "
                [error]="
                  billingEmail.errors
                    | formControlError
                      : showError || billingEmail.touched || billingEmail.dirty
                "
                [errorText]="
                  billingEmail.errors
                    | formControlKeyError
                      : 'organization.details.fields.billingEmail.validation'
                      : showError || billingEmail.touched || billingEmail.dirty
                    | transloco
                "
                [showLabelHint]="!!organizationDetailData.billingEmail"
                [required]="!!organizationDetailData.billingEmail"
                [outlined]="true"
              >
              </markant-input>
              <markant-select
                *ngIf="
                  organizationForm.controls[
                    'billingLanguageIsoCode'
                  ] as billingLanguageIsoCode
                "
                id="billingDetails-billingLanguageIsoCode"
                name="billingLanguageIsoCode"
                formControlName="billingLanguageIsoCode"
                [options]="validIsoCodeOptions"
                [label]="
                  'organization.details.fields.billingLanguageIsoCode.label'
                    | transloco
                "
                [outlined]="true"
              >
              </markant-select>
            </markant-platform-ui-card>
          </div>
          <div class="grid-item">
            <markant-platform-ui-card
              formGroupName="paymentInformation"
              [headline]="'organization.details.paymentInformation' | transloco"
            >
              <markant-input
                *ngIf="organizationForm.get('paymentInformation.iban') as iban"
                id="organization-iban"
                data-cy="input-organization-iban"
                formControlName="iban"
                [label]="
                  'organization.details.fields.paymentInformation.iban.label'
                    | transloco
                "
                [error]="
                  iban.errors
                    | formControlError: showError || iban.touched || iban.dirty
                "
                [errorText]="
                  iban.errors
                    | formControlKeyError
                      : 'organization.details.fields.paymentInformation.iban.validation'
                      : showError || iban.touched || iban.dirty
                    | transloco
                "
                [outlined]="true"
              >
              </markant-input>
              <markant-input
                *ngIf="organizationForm.get('paymentInformation.bic') as bic"
                id="organization-bic"
                data-cy="input-organization-bic"
                formControlName="bic"
                [label]="
                  'organization.details.fields.paymentInformation.bic.label'
                    | transloco
                "
                [error]="
                  bic.errors
                    | formControlError: showError || bic.touched || bic.dirty
                "
                [errorText]="
                  bic.errors
                    | formControlKeyError
                      : 'organization.details.fields.paymentInformation.bic.validation'
                      : showError || bic.touched || bic.dirty
                    | transloco
                "
                [outlined]="true"
              >
              </markant-input>
              <markant-input
                *ngIf="organizationForm.get('paymentInformation.bank') as bank"
                id="organization-bank"
                data-cy="input-organization-bank"
                formControlName="bank"
                [label]="
                  'organization.details.fields.paymentInformation.bank.label'
                    | transloco
                "
                [error]="
                  bank.errors
                    | formControlError: showError || bank.touched || bank.dirty
                "
                [errorText]="
                  bank.errors
                    | formControlKeyError
                      : 'organization.details.fields.paymentInformation.bank.validation'
                      : showError || bank.touched || bank.dirty
                    | transloco
                "
                [outlined]="true"
              >
              </markant-input>
            </markant-platform-ui-card>
            <markant-platform-ui-card
              [headline]="'organization.details.techData' | transloco"
            >
              <ng-container *ngIf="isCurrentUserPlatformAdmin">
                <markant-input
                  *ngIf="organizationForm.controls.markantId as markantId"
                  id="markantId"
                  data-cy="input-markantId"
                  name="markantId"
                  formControlName="markantId"
                  [label]="
                    'organization.details.fields.markantId.label' | transloco
                  "
                  [outlined]="true"
                  [error]="
                    markantId.errors
                      | formControlError
                        : showError || markantId.touched || markantId.dirty
                  "
                  [showLabelHint]="!!organizationDetailData.markantId"
                  [required]="!!organizationDetailData.markantId"
                  [errorText]="
                    markantId.errors
                      | formControlKeyError
                        : 'organization.details.fields.markantId.validation'
                        : showError || markantId.touched || markantId.dirty
                      | transloco
                  "
                  [useCustomLayout]="true"
                ></markant-input>
              </ng-container>
              <markant-input
                id="organization-id"
                data-cy="input-organization-id"
                formControlName="id"
                [label]="'organization.details.fields.technical.id' | transloco"
                [outlined]="true"
              ></markant-input>
              <ng-container *ngIf="isCurrentUserPlatformAdmin">
                <markant-input
                  id="customerNumber"
                  data-cy="input-customerNumber"
                  name="customerNumber"
                  formControlName="customerNumber"
                  [label]="
                    'organization.details.fields.technical.customerNumber'
                      | transloco
                  "
                  [outlined]="true"
                ></markant-input>
                <markant-input
                  id="crmId"
                  data-cy="input-crmId"
                  name="crmId"
                  formControlName="crmId"
                  [label]="'register.organization.crmId' | transloco"
                  [outlined]="true"
                ></markant-input>
              </ng-container>
            </markant-platform-ui-card>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<markant-platform-modal-bridge>
  <markant-dialog
    *ngIf="openApprovalDialog"
    class="master-kin-change-approval-dialog"
    [open]="true"
    (close)="closeDialog()"
  >
    <h2 class="dialog-header">
      {{ 'organization.details.masterKinChangedTitle' | transloco }}
    </h2>

    <div
      class="dialog-content"
      [innerHTML]="'organization.details.masterKinChangedText' | transloco"
    ></div>

    <div slot="markant-dialog-footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        data-markant-dialog-action="submit"
        (click)="approveMasterKinChanges()"
        (keydown.enter)="approveMasterKinChanges()"
      >
        <span>{{ 'common.save' | transloco }}</span>
      </markant-button>

      <markant-button [routerLink]="['..']">
        <span>{{ 'common.cancel' | transloco }}</span>
      </markant-button>
    </div>
  </markant-dialog>
  <markant-dialog
    *ngIf="openMarkantOrganizationChangeDialog"
    class="markant-organization-change-approval-dialog"
    [open]="openMarkantOrganizationChangeDialog"
    (close)="closeMarkantOrganizationChangeDialog(false)"
  >
    <h2 class="dialog-header">
      {{ 'organization.details.markantOrganizationChangedTitle' | transloco }}
    </h2>

    <div
      class="dialog-content"
      [innerHTML]="
        'organization.details.markantOrganizationChangedText' | transloco
      "
    ></div>

    <div slot="markant-dialog-footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        (click)="closeMarkantOrganizationChangeDialog(false)"
        (keydown.enter)="closeMarkantOrganizationChangeDialog(false)"
      >
        <span>{{ 'common.cancel' | transloco }}</span>
      </markant-button>
      <markant-button
        (click)="closeMarkantOrganizationChangeDialog(true)"
        (keydown.enter)="closeMarkantOrganizationChangeDialog(true)"
        data-markant-dialog-action="submit"
      >
        <span>{{ 'common.approve' | transloco }}</span>
      </markant-button>
    </div>
  </markant-dialog>

  @if (
    (isCurrentUserPlatformAdmin || isCurrentUserOA) && isAuditReasonDialogOpen
  ) {
    <markant-platform-audit-reason-dialog
      (saveChanges)="saveUserWithReason($event)"
      (closed)="closeAuditReasonDialog()"
    >
    </markant-platform-audit-reason-dialog>
  }
</markant-platform-modal-bridge>
